module.exports = __webpack_public_path__ + "static/media/lets-work-together.57891297.svg";